namespace $.$$ {

	export class $shm_ba_summary extends $.$shm_ba_summary {

		cards() {
			const table = this.table() as $shm_ba_data_table | null
			return table?.head.map( ( _, index )=> this.Card( index ) ) ?? []
		}

		card_title( index: number ) {
			return ( this.table() as $shm_ba_data_table | null )?.head[ index ] ?? ''
		}

		card_metric( index: number ) {
			const title = this.card_title( index )
			const aliases: Record< string, string > = {
				'Всего сообщений': 'Сообщений',
				'Средняя аудитория СМИ': 'Аудитория СМИ',
				'Средняя цитируемость СМИ': 'Цитируемость СМИ',
			}
			return aliases[ title ] ?? title
		}

		card_selected( index: number ) {
			return this.card_metric( index ) === this.selected()
		}

		card_sort( index: number ) {
			const metric = this.card_metric( index )
			return [
				'Аудитория',
				'Просмотры',
				'Комментарии',
				'Вовлеченность',
				'Лайки',
				'Репосты',
				'Аудитория СМИ',
				'Цитируемость СМИ',
			].includes( metric ) ? metric : null
		}

		@ $mol_action
		pick( index: number, next?: Event ) {
			if( next === undefined ) return null
			this.selected( this.card_metric( index ) )

			const sort = this.card_sort( index )
			if( sort ) {
				this.sort_order( 'desc' )
				this.sort( sort )
				this.page( 0 )
			}
			return next
		}

		card_value( index: number ) {
			const table = this.table() as $shm_ba_data_table | null
			return this.format_number( table?.rows[0]?.[ index ] )
		}

		format_number( value: $shm_ba_data_cell ) {
			const text = String( value ?? '' )
			if( !/^-?\d{5,}$/.test( text ) ) return text
			return text.replace( /\B(?=(\d{3})+(?!\d))/g, ' ' )
		}

	}

}
